
import api from './api';

const route = '/muscles';

const MusclesService = {
  getMuscles: () => api.get(route),
  getSingleMuscle: (muscle_id) => api.get(`${route}/${muscle_id}`),
  postMuscle: (muscle) => api.post(route, { ...muscle}),
  putMuscle: (muscle) => api.put(route, { ...muscle}),
  deleteMuscle: (Muscle) => api.delete(`${route}/${Muscle}`),
};

export default MusclesService;